import React from 'react'
import InventoryForm from './RequisitionComponents/OsRequisitionInventoryForm';

const OsrRequisitionPush = () => {
  return (
    <div className='rounded-lg'>
      <InventoryForm permissionType="PUSH" />
    </div>
  )
}

export default OsrRequisitionPush
